import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {InputNumber} from 'primeng/inputnumber';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {ActivityQuote} from '../../../data/project/activity/activity-quote';
import {ProjectActivity} from '../../../data/project/activity/project-activity';
import {ProjectActivityService} from '../../../data/project/activity/project-activity.service';
import {QuotesEmailDialogComponent} from './quotes-email-dialog/quotes-email-dialog.component';

@Component({
    selector: 'app-activity-requests',
    templateUrl: './activity-requests.component.html',
    styleUrls: ['./activity-requests.component.scss']
})
export class ActivityRequestsComponent implements OnInit, OnDestroy {

    @Input()
    projectActivity: ProjectActivity

    activityQuotes: ActivityQuote[]

    quotesLoading = true;

    quoteSendSubj = new Subject<ActivityQuote>();

    lastClicked = -1;

    @Output()
    updateUser = new EventEmitter<number>()


    constructor(
        protected dialog: MatDialog,
        protected projectActivityService: ProjectActivityService
    ) { }

    ngOnInit(): void {
        this.getQuotes();

        this.quoteSendSubj.pipe(debounceTime(500)).subscribe(quote => {

            this.projectActivityService.updateActivityQuote(quote).subscribe(() => {

            })
        })
    }

    getQuotes() {
        this.projectActivityService.getActivityQuotes(this.projectActivity.id).subscribe(quotes => {
            this.activityQuotes = quotes;

            this.quotesLoading = false;
        })
    }

    requestEmail(activityQuote: ActivityQuote) {
        const dialogRef = this.dialog.open(QuotesEmailDialogComponent, {
            data: {
                activityQuote,
                project: this.projectActivity.project
            },
            panelClass: 'quote-email-dialog'
        });

        dialogRef.afterClosed().subscribe(result => {

      if (result && result[0] === 'Cancelled!') {
        this.getQuotes()
      }

      if (result && result[1] === 'Awarded') {
        this.updateUser.emit(activityQuote.addressee.id)
      }

            if (result && result[0] === 'Success!') {
                this.getQuotes()
            }

            if (result && result[1] === 'Awarded') {
                this.updateUser.emit(activityQuote.addressee.id)
            }
        });
    }

    saveAward(quote: ActivityQuote, event) {
        quote = {
            id: quote.id,
            price: event.value,
        } as ActivityQuote;
        this.quoteSendSubj.next(quote)
    }

    onInputClick(awardInput: InputNumber, clickedIndex: number) {

        const tempInput = awardInput.input.nativeElement as HTMLInputElement;
        if (tempInput) {
            if (this.lastClicked !== clickedIndex) {
                tempInput.setSelectionRange(0, tempInput.value.length);
                this.lastClicked = clickedIndex;
            }
        }
    }

    ngOnDestroy() {

    }
}
